import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { FixOrdersTable } from '../../../../../../../../../../features/fix/order/fix-orders-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsOms,
      label: 'FIX Orders',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsOms>,
  head: () => getPageHead('FIX Orders'),
  component: FixOrderList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsOms}
    />
  );
}

function FixOrderList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <FixOrdersTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
